import type { TargetKeywordStats } from '@pepper/utils/src/types/seo'

const CHAR_LIMIT = {
  title: {
    min: 50,
    max: 60,
  },
  description: {
    min: 150,
    max: 160,
  },
}

type MetaData = {
  target_keyword_stats: TargetKeywordStats
  meta: {
    title: {
      content: string
      length: number
      keyword_present: boolean
    }
    description: {
      content: string
      length: number
      keyword_present: boolean
    }
  }
}

export const getMetaCopy = (
  metaData: MetaData,
  type: 'title' | 'description'
) => {
  const { length, keyword_present } = metaData.meta[type]

  const isTooShort = length < CHAR_LIMIT[type].min
  const isTooLong = length > CHAR_LIMIT[type].max
  const isKeywordPresent = Boolean(keyword_present)

  if (!isTooShort && !isTooLong && isKeywordPresent) {
    return `Perfect! Your meta ${type} is in the ideal range.`
  }

  const copy = []
  if (isTooShort) {
    copy.push(
      `Your ${type} length is ${length} characters, which is shorter than the recommended length of ${
        CHAR_LIMIT[type].min
      }-${CHAR_LIMIT[type].max} characters. Add ${
        CHAR_LIMIT[type].min - length
      } characters`
    )
  } else if (isTooLong) {
    copy.push(
      `Your ${type} length is ${length} characters, which is longer than the recommended length of ${
        CHAR_LIMIT[type].min
      }-${CHAR_LIMIT[type].max} characters. Remove ${
        length - CHAR_LIMIT[type].max
      } characters`
    )
  }
  if (!isKeywordPresent) {
    copy.push(
      `mention the keyword "${metaData.target_keyword_stats.keyword}" at-least once.`
    )
  }
  return copy.join(' and ')
}
